export const ANALYTICS_CHANNEL = 'media';
export const DATASOURCE_DEFAULT_LAYOUT = 'wide';
